var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(17.749 18.163) rotate(180)"},[React.createElement("path",{"d":"M16.749,0H0","transform":"translate(0 8.374)","fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M8.374,16.749,0,8.374,8.374,0","transform":"translate(0 0)","fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1})]));
}

Arrow.defaultProps = {"width":"18.749","height":"19.577","viewBox":"0 0 18.749 19.577"};

module.exports = Arrow;

Arrow.default = Arrow;
